import { useSelector } from "react-redux"
import { useStageFunnel } from "../context/StageFunnelContext"

/**
 * L'identifiant du parcours, lu au Context PUIS au store — pendant de
 * `useInscriptionLead`. Le store est alimenté par le middleware api quel que
 * soit l'écran monté : il sert de repli quand le Context n'a pas encore reçu
 * la réponse de /start ou de /init.
 */
export const useStageLead = () => {
    const { state } = useStageFunnel()
    const storeStateId = useSelector((s) => s.data?.stageFunnel?.funnelStateId)

    return { funnelStateId: state.funnelStateId || storeStateId || null }
}
